// import React, { useContext, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { AuthContext } from "../context/Authcontext";

// import ForgotPassword from "../views/components/ForgotPassword";
// import ToastMessage from "../views/components/ToastMessage";

// export default function LoginReg({
//   active,
//   setactive,
//   regactive,
//   setregactive,
// }) {
//   const [setFormData, setFormData] = useState({
//     username: "",
//     phoneNumber: "",
//     pwd: "",
//     cpassword: "",
//     invitecode: "",
//     imOver18: false,
//     iAcceptAll: false,
//   });
//   const navigate = useNavigate();

//   const [loginFormData, setLoginFormData] = useState({
//     phoneNumber: "",
//     password: "",
//     iAcceptAll: true,
//   });
//   const { Register, login, setIsAuthenticated } = useContext(AuthContext);
//   const [forgotPasswordActive, setForgotPasswordActive] = useState(false);
//   const [isPassVisible, setPassVisible] = useState(false);
//   const [isConfPassViss, setConfPassVisible] = useState(false);
//   const [loading, setLoading] = useState(false); // Added loading state

//   const handleForgotPasswordClick = () => {
//     // Close login modal before opening forgot password
//     setactive(false);
//     setForgotPasswordActive(true);
//   };
//   const handleCloseForgotPassword = () => {
//     setForgotPasswordActive(false);
//     // Optionally reopen login modal
//     setactive(true);
//   };
//   const handleclearRegisterForm = () => {
//     setFormData({
//       username: "",
//       phoneNumber: "",
//       pwd: "",
//       cpassword: "",
//       invitecode: "",
//       imOver18: false,
//       iAcceptAll: false,
//     });
//   };
//   const handleclearLoginForm = () => {
//     setLoginFormData({
//       phoneNumber: "",
//       password: "",
//       iAcceptAll: false,
//     });
//   };
//   const submitregister = (e) => {

//     e.preventDefault();
//     if (
//       !setFormData.username ||
//       !setFormData.phoneNumber ||
//       !setFormData.cpassword ||
//       !setFormData.pwd ||
//       !setFormData.imOver18 ||
//       !setFormData.iAcceptAll
//     ) {
//       ToastMessage(0, "All fields are required!");
//       return;
//     }
//     let { imOver18, iAcceptAll, ...data } = setFormData;

//     Register(data, function (res) {
//       if (res.status) {
//         ToastMessage(1, res.message);
//         handleclearRegisterForm();
//         // navigate('/');
//         setactive(true);
//         setregactive(false);

//       } else {
//         ToastMessage(0, res.message);
//       }
//     });
//   };

//   const submitlogin = (e) => {
//     e.preventDefault();
//     if (!loginFormData.phoneNumber || !loginFormData.password) {
//       ToastMessage(0, "All fields are required!");
//       return;
//     }
//     if(!loginFormData.iAcceptAll){
//       ToastMessage(0,"Please Accept The Terms And Conditions");
//       return;
//     }
//     let { iAcceptAll, ...data } = loginFormData;
//     login(data, function (res) {
//       if (res.status) {
//         setIsAuthenticated(true);
//         ToastMessage(1, res.message);
//         handleclearLoginForm();

//         setactive(false);
//         setregactive(false);
//         navigate('/');

//       } else {
//         ToastMessage(0, res.message);
//       }
//     });
//   };

//   const handleDemoLogin = async () => {
//     setLoading(true);
//     const demoCredentials = {
//       phoneNumber: "9999999999",
//       password: "123456",
//     };
//     login(demoCredentials, function (res) {
//       setLoading(false);
//       if(res.status){
//         setIsAuthenticated(true);
//         ToastMessage(1, res.message);
//         setactive(false);
//         setregactive(false);
//         navigate("/");
//       } else {
//         ToastMessage(0, res.message);
//       }
//     })
// }

//   return (
//     <>
//       {/* Login section */}
//       <section
//         style={{ zIndex: 1050 }}
//         aria-hidden="true"
//         className={`modal-backdrop fade show ${active ? "d-block" : "d-none"} `}
//       ></section>
//       <section
//         role="dialog"
//         tabIndex="-1"
//         aria-modal="true"
//         className={`modal fade show ${active ? "d-block" : "d-none"} `}
//       >
//         <div
//           role="document"
//           className="modal-dialog"
//           style={{
//             display: "flex",
//             alignItems: "center",
//             borderRadius: "13px",
//           }}
//         >
//           <div className="modal-content">
//           {/* <div> */}
//             <div _ngcontent-crs-c59="" appclickoutside="" className="">
//               <button
//                 _ngcontent-crs-c59=""
//                 type="button"
//                 onClick={() => setactive(false)}
//                 className="close modal-close-button"
//               >
//                 <i className="bi bi-x cross_icon text-white"></i>
//               </button>
//               <div _ngcontent-crs-c59="" className="px-5 form-box py-5">
//                 <div
//                   _ngcontent-crs-c59=""
//                   className="text-center header-box d-flex align-items-center justify-content-center"
//                 >
//                   <img
//                     _ngcontent-crs-c59=""
//                     className="top_dark logo-img"
//                     alt="logo"
//                     src="/assets/images/rajbet65-logo.png"
//                   />
//                 </div>
//                 <form
//                   _ngcontent-crs-c59=""
//                   onSubmit={submitlogin}
//                   noValidate=""
//                   className="ng-untouched ng-pristine ng-invalid"
//                 >
//                   <div _ngcontent-crs-c59="" className="pt-5">
//                     <span
//                       _ngcontent-crs-c59=""
//                       className="d-flex align-items-center form-floating"
//                     >
//                       <input
//                         _ngcontent-crs-c59=""
//                         autoComplete="username"
//                         value={loginFormData.phoneNumber}
//                         onChange={(e) =>
//                           setLoginFormData({
//                             ...loginFormData,
//                             phoneNumber: e.target.value.replace(/[^0-9]/, ""),
//                           })
//                         }
//                         formcontrolname="username"
//                         className="text-dark lm form-control ng-untouched ng-pristine ng-invalid"
//                         style={{ height: "43px !important" }}
//                         placeholder="Mobile No"
//                         maxLength={10}
//                       />
//                       <label _ngcontent-crs-c59="" className="floating-label">
//                         Mobile No
//                       </label>
//                     </span>
//                   </div>
//                   <div _ngcontent-crs-c59="" className="pt-3">
//                     <div _ngcontent-crs-c59="" className="inner-addon">
//                       <span
//                         _ngcontent-crs-c59=""
//                         className="d-flex align-items-center form-floating"
//                       >
//                         <div
//                           className={`p_hide_icon ${
//                             isPassVisible ? "d-none" : ""
//                           }`}
//                           onClick={() => setPassVisible(!isPassVisible)}
//                         >
//                           <i className="bi bi-eye-slash"></i>
//                         </div>
//                         <div
//                           className={`p_hide_icon ${
//                             isPassVisible ? "" : "d-none"
//                           }`}
//                           onClick={() => setPassVisible(!isPassVisible)}
//                         >
//                           <i className="bi bi-eye-fill"></i>
//                         </div>
//                         <input
//                           _ngcontent-crs-c59=""
//                           value={loginFormData.password}
//                           onChange={(e) =>
//                             setLoginFormData({
//                               ...loginFormData,
//                               password: e.target.value,
//                             })
//                           }
//                           formcontrolname="password"
//                           className="text-dark lm form-control ng-untouched ng-pristine ng-invalid"
//                           placeholder="Password"
//                           type={isPassVisible ? "text" : "password"}
//                         />
//                         <label _ngcontent-crs-c59="" className="floating-label">
//                           Password
//                         </label>
//                       </span>
//                     </div>
//                   </div>
//                   <div
//                     _ngcontent-crs-c59=""
//                     className="pt-3 input_field_with_logo"
//                   >
//                     <div _ngcontent-crs-c59="" className="inner-addon">
//                       <div
//                         _ngcontent-crs-c59=""
//                         className="policy row gap-1"
//                         style={{ flexWrap: "nowrap" }}
//                       >
//                         <input
//                           className="col-md-1 form-check-input shadow-none border-0 mb-1"
//                           type="checkbox"
//                           id="imover18_1"
//                           checked={loginFormData.iAcceptAll}
//                           onChange={(e) =>
//                             setLoginFormData({
//                               ...loginFormData,
//                               iAcceptAll: e.target.checked,
//                             })
//                           }
//                         />
//                         <h3
//                           _ngcontent-crs-c59=""
//                           className="col-md-11 text-center"
//                         >
//                           {" "}
//                           I accept all the{" "}
//                           <Link
//                             _ngcontent-crs-c59=""
//                             routerlinkactive="router-link-active"
//                             style={{ textDecoration: "underline" }}
//                           >
//                             {" "}
//                             Terms &amp; Conditions
//                           </Link>
//                         </h3>
//                       </div>
//                       <p
//                         className="loginLink m-0 text-right ng-star-inserted"
//                         onClick={handleForgotPasswordClick}
//                       >
//                         <Link
//                           style={{
//                             position: "relative",
//                             color: themeColors['--text-color) !important",
//                           }}
//                         >
//                           Forgot Password?
//                         </Link>
//                       </p>
//                     </div>
//                   </div>
//                   <div _ngcontent-crs-c59="" className="pt-3">
//                     <button
//                       _ngcontent-crs-c59=""
//                       type="submit"
//                       className="login-btn"
//                     >
//                       Login{" "}
//                     </button>
//                   </div>
//                 </form>
//                 <div _ngcontent-crs-c59="" className="pt-3">
//                   <button
//                     _ngcontent-crs-c59=""
//                     type="submit"
//                     className="login-btn"
//                     onClick={handleDemoLogin}
//                   >
//                     Demo
//                   </button>
//                 </div>
//                 <div _ngcontent-crs-c59="" className="pt-3">
//                   <button
//                     _ngcontent-crs-c59=""
//                     type="submit"
//                     className="login-btn1  d-flex justify-content-center gap-3   "
//                   >
//                     <i class="bi bi-android2 text-white"></i>
//                     <p style={{ marginTop: "5px" }}>Download App</p>
//                   </button>
//                 </div>
//                 <div _ngcontent-crs-c59="" className="bottom_create">
//                   <p
//                     _ngcontent-crs-c59=""
//                     className="signup_add"
//                     onClick={() => navigate("/registerPage")}
//                   >
//                     Create New Account
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <ForgotPassword
//         forgotPasswordActive={forgotPasswordActive}
//         setForgotPasswordActive={handleCloseForgotPassword}
//         onClose={handleCloseForgotPassword}
//       />

//       {/* Registration Section */}
//       <section
//         style={{ zIndex: 1050 }}
//         aria-hidden="true"
//         className={`modal-backdrop fade show ${
//           regactive ? "d-block" : "d-none"
//         } `}
//       ></section>
//       <section
//         role="dialog"
//         tabIndex="-1"
//         aria-modal="true"
//         className={`modal fade show ${regactive ? "d-block" : "d-none"} `}
//       >
//         <div role="document" className="modal-dialog">
//           <div className="">
//             <div
//               _ngcontent-crs-c59=""
//               appclickoutside=""
//               className="modal-body"
//             >
//               <button
//                 _ngcontent-crs-c59=""
//                 type="button"
//                 onClick={() => setregactive(false)}
//                 className="close modal-close-button"
//               >
//                 <i className="bi bi-x cross_icon"></i>
//               </button>
//               <div _ngcontent-crs-c59="" className="px-5 form-box py-5">
//                 <div
//                   _ngcontent-crs-c59=""
//                   className="text-center header-box d-flex align-items-center justify-content-center"
//                 >
//                   <span>SIGN UP</span>
//                 </div>
//                 <form
//                   _ngcontent-crs-c59=""
//                   onSubmit={submitregister}
//                   noValidate=""
//                   className="ng-untouched ng-pristine ng-invalid"
//                 >
//                   <div _ngcontent-crs-c59="" className="pt-3">
//                     <span
//                       _ngcontent-crs-c59=""
//                       className="d-flex align-items-center form-floating"
//                     >
//                       <input
//                         _ngcontent-crs-c59=""
//                         autoComplete="username"
//                         value={setFormData.username}
//                         onChange={(e) =>
//                           setFormData({
//                             ...setFormData,
//                             username: e.target.value,
//                           })
//                         }
//                         formcontrolname="username"
//                         className="text-dark lm form-control ng-untouched ng-pristine ng-invalid"
//                         placeholder="Username"
//                       />
//                       <label _ngcontent-crs-c59="" className="floating-label">
//                         User Name
//                       </label>
//                     </span>
//                   </div>
//                   <div _ngcontent-crs-c59="" className="pt-2">
//                     <span
//                       _ngcontent-crs-c59=""
//                       className="d-flex align-items-center form-floating"
//                     >
//                       <input
//                         _ngcontent-crs-c59=""
//                         maxLength={10}
//                         value={setFormData.phoneNumber}
//                         onChange={(e) =>
//                           setFormData({
//                             ...setFormData,
//                             phoneNumber: e.target.value.replace(/[^0-9]/, ""),
//                           })
//                         }
//                         formcontrolname="username"
//                         className="text-dark lm form-control ng-untouched ng-pristine ng-invalid"
//                         placeholder="Username"
//                       />
//                       <label _ngcontent-crs-c59="" className="floating-label">
//                         Mobile No
//                       </label>
//                     </span>
//                   </div>

//                   <div _ngcontent-crs-c59="" className="pt-2">
//                     <div _ngcontent-crs-c59="" className="inner-addon">
//                       <span
//                         _ngcontent-crs-c59=""
//                         className="d-flex align-items-center form-floating"
//                       >
//                         <div
//                           className={`p_hide_icon ${
//                             isPassVisible ? "d-none" : ""
//                           }`}
//                           onClick={() => setPassVisible(!isPassVisible)}
//                         >
//                           <i className="bi bi-eye-slash"></i>
//                         </div>
//                         <div
//                           className={`p_hide_icon ${
//                             isPassVisible ? "" : "d-none"
//                           }`}
//                           onClick={() => setPassVisible(!isPassVisible)}
//                         >
//                           <i className="bi bi-eye-fill"></i>
//                         </div>
//                         <input
//                           _ngcontent-crs-c59=""
//                           autoComplete="current-password"
//                           value={setFormData.pwd}
//                           onChange={(e) =>
//                             setFormData({
//                               ...setFormData,
//                               pwd: e.target.value,
//                             })
//                           }
//                           formcontrolname="password"
//                           className="text-dark lm form-control ng-untouched ng-pristine ng-invalid"
//                           placeholder="Password"
//                           type={isPassVisible ? "text" : "password"}
//                         />
//                         <label _ngcontent-crs-c59="" className="floating-label">
//                           Password
//                         </label>
//                       </span>
//                     </div>
//                   </div>
//                   <div _ngcontent-crs-c59="" className="pt-2">
//                     <div _ngcontent-crs-c59="" className="inner-addon">
//                       <span
//                         _ngcontent-crs-c59=""
//                         className="d-flex align-items-center form-floating"
//                       >
//                         <div
//                           className={`p_hide_icon ${
//                             isConfPassViss ? "d-none" : ""
//                           }`}
//                           onClick={() => setConfPassVisible(!isConfPassViss)}
//                         >
//                           <i className="bi bi-eye-slash"></i>
//                         </div>
//                         <div
//                           className={`p_hide_icon ${
//                             isConfPassViss ? "" : "d-none"
//                           }`}
//                           onClick={() => setConfPassVisible(!isConfPassViss)}
//                         >
//                           <i className="bi bi-eye-fill"></i>
//                         </div>

//                         <input
//                           _ngcontent-crs-c59=""
//                           autoComplete="current-password"
//                           value={setFormData.cpassword}
//                           onChange={(e) =>
//                             setFormData({
//                               ...setFormData,
//                               cpassword: e.target.value,
//                             })
//                           }
//                           formcontrolname="password"
//                           className="text-dark lm form-control ng-untouched ng-pristine ng-invalid"
//                           placeholder="Password"
//                           type={isConfPassViss ? "text" : "password"}
//                         />
//                         <label _ngcontent-crs-c59="" className="floating-label">
//                           Confirm Password
//                         </label>
//                       </span>
//                     </div>
//                   </div>
//                   <div _ngcontent-crs-c59="" className="pt-2">
//                     <span
//                       _ngcontent-crs-c59=""
//                       className="d-flex align-items-center form-floating"
//                     >
//                       <span _ngcontent-crs-c59="" className="user_icon">
//                         <svg
//                           _ngcontent-crs-c59=""
//                           className="svg-inline--fa fa-user fa-w-14"
//                           aria-hidden="true"
//                           focusable="false"
//                           data-prefix="fa"
//                           data-icon="user"
//                           role="img"
//                           xmlns="http://www.w3.org/2000/svg"
//                           viewBox="0 0 448 512"
//                           data-fa-i2svg=""
//                         >
//                           <path
//                             fill="currentColor"
//                             d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
//                           ></path>
//                         </svg>
//                       </span>
//                       <input
//                         _ngcontent-crs-c59=""
//                         type="text"
//                         value={setFormData.invitecode}
//                         onChange={(e) =>
//                           setFormData({
//                             ...setFormData,
//                             invitecode: e.target.value,
//                           })
//                         }
//                         formcontrolname="username"
//                         className="text-dark lm form-control ng-untouched ng-pristine ng-invalid"
//                         placeholder="Username"
//                       />
//                       <label _ngcontent-crs-c59="" className="floating-label">
//                         Invitation Code
//                       </label>
//                     </span>
//                   </div>
//                   <div
//                     _ngcontent-crs-c59=""
//                     className="pt-3 input_field_with_logo"
//                   >
//                     <div _ngcontent-crs-c59="" className="inner-addon">
//                       <div className="form-check">
//                         <input
//                           className="col-md-1 form-check-input shadow-none border-0"
//                           type="checkbox"
//                           onChange={(e) =>
//                             setFormData({
//                               ...setFormData,
//                               imOver18: e.target.checked,
//                             })
//                           }
//                           checked={setFormData.imOver18}
//                           id="imover18"
//                         />
//                         <label
//                           className="form-check-label text-white"
//                           htmlFor="imover18"
//                         >
//                           I'm over 18
//                         </label>
//                       </div>
//                     </div>
//                   </div>
//                   <div
//                     _ngcontent-crs-c59=""
//                     className="pt-2 input_field_with_logo"
//                   >
//                     <div _ngcontent-crs-c59="" className="inner-addon">
//                       <div className="form-check">
//                         <input
//                           className="col-md-1 form-check-input shadow-none border-0"
//                           type="checkbox"
//                           onChange={(e) =>
//                             setFormData({
//                               ...setFormData,
//                               iAcceptAll: e.target.checked,
//                             })
//                           }
//                           checked={setFormData.iAcceptAll}
//                           id="iaccept"
//                         />
//                         <label
//                           className="form-check-label text-white"
//                           htmlFor="iaccept"
//                         >
//                           I accept all the
//                         </label>
//                         <Link
//                           className="ms-2 cursor-pointer"
//                           style={{ textDecoration: "underline" }}
//                         >
//                           Terms &amp; Conditions
//                         </Link>
//                       </div>
//                     </div>
//                   </div>

//                   <div _ngcontent-crs-c59="" className="pt-2">
//                     <button
//                       _ngcontent-crs-c59=""
//                       type="submit"
//                       className="login-btn"
//                     >
//                       Register
//                     </button>
//                   </div>
//                 </form>
//                 <div _ngcontent-crs-c59="" className="bottom_create">
//                   <p
//                     _ngcontent-crs-c59=""
//                     className="addition_className ng-star-inserted"
//                   >
//                     <Link
//                       _ngcontent-crs-c59=""
//                       style={{ textDecoration: "underline" }}
//                     >
//                       Already have an account?
//                     </Link>
//                   </p>
//                   <p
//                     _ngcontent-crs-c59=""
//                     onClick={() => {
//                       setactive(true);
//                       setregactive(false);
//                     }}
//                     className="signup_add"
//                   >
//                     Login
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }

import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import { Form } from "react-bootstrap";
import { AuthContext } from "../context/Authcontext";
import ForgotPassword from "../views/components/ForgotPassword";
import SignInHelp from "./components/SignInHelp";
import ToastMessage from "../views/components/ToastMessage";
import "../assets/AdminCss/auth-form.css";
import { useTheme } from "../context/ThemeContext";
import CaptchaBox from "./components/CaptchaBox";
import toast from "react-hot-toast";
import { Button, InputGroup } from "react-bootstrap";
import { Eye, EyeOff } from "lucide-react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
export default function LoginReg({
  active,
  setactive,
  regactive,
  setregactive,
}) {
  const [formData, setFormData] = useState({
    username: "",
    phoneNumber: "",
    cpassword: "",
    pwd: "",
    invite: "354409588405",
    imOver18: true,
    iAcceptAll: true,
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const captchaRef = useRef();
  const { themeColors } = useTheme();
  const [loading2, setLoading2] = useState(false);

  const [loginFormData, setLoginFormData] = useState({
    username: "",
    password: "",
    iAcceptAll: true,
  });
  const { Register, login, isAuthenticated, setIsAuthenticated, cookiesBlocked } =
    useContext(AuthContext);
  const [forgotPasswordActive, setForgotPasswordActive] = useState(false);
  // Admin-assisted account recovery: "password" resets, "userid" recovers
  // the username. Both point the user to support (see SignInHelp).
  const [helpMode, setHelpMode] = useState(null); // null | "password" | "userid"
  const [isPassVisible, setPassVisible] = useState(false);
  const [isConfPassViss, setConfPassVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showTerms, setShowTerms] = useState(false);

  const handleForgotPasswordClick = () => {
    setactive(false);
    setForgotPasswordActive(true);
  };
  const handleCloseForgotPassword = () => {
    setForgotPasswordActive(false);
    setactive(true);
  };
  const handleclearRegisterForm = () => {
    setFormData({
      username: "",
      phoneNumber: "",
      pwd: "",
      cpassword: "",
      invitecode: "",
      imOver18: false,
      iAcceptAll: false,
    });
  };
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleclearLoginForm = () => {
    setLoginFormData({
      phoneNumber: "",
      password: "",
      iAcceptAll: false,
    });
  };
const submitregister = (e) => {
    e.preventDefault();
 
    const {
      username,
      phoneNumber,
      cpassword,
      pwd,
      invite,
      imOver18,
      iAcceptAll,
    } = formData;
 
    // 🔹 Field validations with specific messages
    if (!username) {
      ToastMessage(0, "User ID is required!");
      return;
    }
 
    if (!phoneNumber) {
      ToastMessage(0, "Mobile  is required!");
      return;
    }
 
    if (phoneNumber.length < 10) {
      ToastMessage(0, "Mobile  must be at least 10 characters!");
      return;
    }
 
    if (!cpassword) {
      ToastMessage(0, "Password is required!");
      return;
    }
 
    if (cpassword.length < 6) {
      ToastMessage(0, "Password must be at least 6 characters!");
      return;
    }
 
    if (!pwd) {
      ToastMessage(0, "Confirm Password is required!");
      return;
    }
 
    if (pwd.length < 6) {
      ToastMessage(0, "Confirm Password must be at least 6 characters!");
      return;
    }
 
    if (pwd !== cpassword) {
      ToastMessage(0, "Password and Confirm Password do not match!");
      return;
    }
 
    if (!imOver18) {
      ToastMessage(0, "You must confirm that you are over 18!");
      return;
    }
 
    if (!iAcceptAll) {
      ToastMessage(0, "You must accept all terms & conditions!");
      return;
    }
 
    // 🔹 Final data object
    const data = {
      username,
      phoneNumber,
      pwd,
      cpassword,
      invite,
    };
 
    Register(data, function (res) {
      if (res.status) {
        ToastMessage(1, res.message);
        handleclearRegisterForm();
 
        const loginData = {
          username,
          password: pwd,
        };
 
        login(loginData, function (res) {
          if (res.status) {
            setIsAuthenticated(true);
            setactive(false);
            setregactive(false);
            navigate("/");
          } else {
            ToastMessage(0, "Login failed after registration");
          }
        });
      } else {
        ToastMessage(0, res.message);
      }
    });
  };
 
  const submitlogin = (e) => {
    e.preventDefault();
    setLoading2(true);
    const timeout = setTimeout(() => {
      setLoading2(false);
    }, 2000);
    // One message, for the first thing that is actually wrong. The length
    // check used to run first, so an empty form said "Password must be at
    // least 6 characters!" and the required-field errors were never shown.
    const newErrors = {};
    if (!loginFormData.username) newErrors.username = "User ID is required.";
    if (!loginFormData.password) newErrors.password = "Password is required.";

    const firstProblem =
      newErrors.username ||
      newErrors.password ||
      (loginFormData.password.length < 6 ? "Password must be at least 6 characters." : "");

    if (firstProblem) {
      setErrors(newErrors);
      ToastMessage(0, firstProblem);
      setLoading2(false);
      return;
    }

    // Reset errors if validation passes
    setErrors({});

    if (!captchaRef.current?.validateCaptcha()) {
      // Was a blocking browser alert().
      ToastMessage(0, "Wrong answer to the sum. Please try again.");
      setLoading2(false);
      return;
    }
 
    if (!loginFormData.iAcceptAll) {
      ToastMessage(0, "Please Accept The Terms And Conditions");
      setLoading2(false);
      return;
    }
 
    let { iAcceptAll, ...data } = loginFormData;
 
    const payload = {
      ...data,
      username: data.username,
    };
 
    login(payload, function (res) {
      clearTimeout(timeout);
      setLoading2(false);
      if (res.status) {
        console.log("LOGIN RESPONSE:", res.data);
        setIsAuthenticated(true);
        ToastMessage(1, res.message);
        handleclearLoginForm();
        setactive(false);
        setregactive(false);
        navigate("/home");
      } else {
        ToastMessage(0, res.message);
      }
    }, function (err) {
      clearTimeout(timeout);
      setLoading2(false);  
      ToastMessage(0, "Something went wrong!");
    });
  };

  const handleDemoLogin = async () => {
    setLoading(true);
    const demoCredentials = {
      username: "demo",
      password: "123456",
    };
    login(demoCredentials, function (res) {
      setLoading(false);
      if (res.status) {
        setIsAuthenticated(true);
        ToastMessage(1, res.message);
        setactive(false);
        setregactive(false);
        navigate("/home");
      } else {
        ToastMessage(0, res.message);
      }
    });
  };
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.6)",
    backdropFilter: "blur(6px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    animation: "fadeIn 0.3s ease",
  },

  modal: {
    width: "367px",
    maxHeight: "60vh",
    background: "rgba(255,255,255,0.95)",
    border: "5px solid #1d84c6",
    boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    animation: "scaleUp 0.3s ease",
  },

  header: {
    padding: "16px 20px",
    borderBottom: "1px solid #eee",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  title: {
    margin: 0,
    fontSize: "20px",
    fontWeight: "600",
    color: "#333",
  },

  close: {
    cursor: "pointer",
    fontSize: "20px",
    color: "#888",
  },

  body: {
    padding: "20px",
    overflowY: "auto",
    fontSize: "14px",
    color: "#444",
  },

  card: {
    background: "#f8f9ff",
    borderRadius: "10px",
    padding: "12px",
    marginBottom: "12px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
  },

  footer: {
    padding: "15px 20px",
    borderTop: "1px solid #eee",
    display: "flex",
    justifyContent: "space-between",
  },

  acceptBtn: {
    background: "linear-gradient(135deg, #4facfe, #00f2fe)",
    border: "none",
    color: "#fff",
    padding: "10px 18px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "600",
  },

  declineBtn: {
    background: "#ff0000",
    border: "none",
    padding: "10px 18px",
    borderRadius: "8px",
    cursor: "pointer",
  },
};

useEffect(() => {
  if (active || regactive || showTerms) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return () => {
    document.body.style.overflow = "auto";
  };
}, [active, regactive, showTerms]);

  //   useEffect(() => {
  //   if (!isAuthenticated) {
  //     navigate("/", { replace: true })
  //   }
  // }, [isAuthenticated]);

  // The header, the carousel, the game grids and several cards each mount
  // their own LoginReg, so a single page carried ten copies of both dialogs
  // -- duplicate ids (#solution, #login-terms) and ten hidden forms (#7).
  // A closed instance renders nothing; only the one the visitor opened is
  // in the DOM. Every hook above still runs, so hook order is unchanged.
  if (!active && !regactive && !forgotPasswordActive && helpMode === null && !showTerms) {
    return null;
  }

  return (
    <>
      {/* Login Section */}
      <div
        className={`auth-backdrop ${active ? "auth-visible" : "auth-hidden"}`}
      ></div>
      <div
        role="dialog"
        tabIndex="-1"
        aria-modal="true"
        className={`auth-modal ${active ? "auth-visible" : "auth-hidden"}`}
      >
        <div className="auth-modal-dialog">
          <div className="auth-modal-content">
            <button
              type="button"
              onClick={() => {setactive(false)
             setLoginFormData({
  username: "",
  password: "",
  iAcceptAll: true, // keep default or change if needed
});
              }}
              className="auth-close-button"
            >
              <i className="bi bi-x auth-cross-icon"></i>
            </button>
            <div className="auth-form-box">
              {cookiesBlocked && (
                <p className="rb-cookie-warn" role="alert">
                  Cookies are blocked in this browser, so you won't stay
                  logged in. Enable cookies, or open this site in Chrome or
                  Safari{/(FBAN|FBAV|Instagram|Telegram)/i.test(navigator.userAgent)
                    ? " (use the menu → Open in browser)"
                    : ""}.
                </p>
              )}
              <div className="auth-header-box">
                {/* <img
                  className="auth-logo-img"
                  alt="logo"
                  src="/assets/images/rajbet65-logo.png"
                /> */}
                <h5
                  style={{ color: "#000", marginTop: "8px" }}
                  className="fw-bold"
                >
                  Login
                </h5>
              </div>
              <form onSubmit={submitlogin} noValidate className="auth-form">
                <div className="auth-input-group">
                  <div className="auth-form-floating">
                    <label style={{ color: "#000" }}>
                      USER ID{" "}
                      <span style={{ color: "red", fontSize: "18px" }}>*</span>
                    </label>
                    <br />

                    <input
                      autoComplete="username"
                      style={{ border: "1px solid black", color: "#000" }}

                      type="text"
                      value={loginFormData.username}
                      placeholder="USER ID"

                      onChange={(e) =>
                        setLoginFormData({
                          ...loginFormData,
                          username: e.target.value,
                        })
                      }
                      className="auth-input"
                    />
                    {errors.username && (
                      <small style={{ color: "red" }}>{errors.username}</small>
                    )}
                  </div>
                </div>
                <div className="auth-input-group">
                  <div className="auth-form-floating auth-password-field">
                    <div
                      className={`auth-eye-icon ${isPassVisible ? "auth-hidden" : ""
                        }`}
                      onClick={() => setPassVisible(!isPassVisible)}
                    >
                      <i className="bi bi-eye-slash"></i>
                    </div>
                    <div
                      className={`auth-eye-icon ${isPassVisible ? "" : "auth-hidden"
                        }`}
                      onClick={() => setPassVisible(!isPassVisible)}
                    >
                      <i className="bi bi-eye-fill"></i>
                    </div>
                    <label style={{ color: "#000" }}>
                      PASSWORD
                    </label>{" "}
                    <span style={{ color: "red", fontSize: "18px" }}>*</span>
                    <input
                      value={loginFormData.password}
                      style={{ border: "1px solid black", color: "#000" }}
                      placeholder="PASSWORD"

                      onChange={(e) =>
                        setLoginFormData({
                          ...loginFormData,
                          password: e.target.value,
                        })
                      }
                      className="auth-input"
                      type={isPassVisible ? "text" : "password"}
                    />
                    {errors.password && (
                      <small style={{ color: "red" }}>{errors.password}</small>
                    )}
                  </div>
                </div>
                <div className="auth-help-links" style={{ display: "flex", justifyContent: "space-between", gap: "12px", margin: "6px 2px 10px" }}>
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => setHelpMode("password")}
                    onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setHelpMode("password")}
                    style={{ color: "#159bd3", fontSize: "13px", fontWeight: 600, cursor: "pointer", textDecoration: "underline" }}
                  >
                    Forgot Password?
                  </span>
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={() => setHelpMode("userid")}
                    onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setHelpMode("userid")}
                    style={{ color: "#159bd3", fontSize: "13px", fontWeight: 600, cursor: "pointer", textDecoration: "underline" }}
                  >
                    Forgot User ID?
                  </span>
                </div>
                <CaptchaBox ref={captchaRef} />

                <div className="auth-input-group d-flex my-2 d-none">
                  <div className="auth-policy-group">
                    <input
                      className="auth-checkbox"
                      type="checkbox"
                      id="login-terms"
                      checked={loginFormData.iAcceptAll}
                      onChange={(e) =>
                        setLoginFormData({
                          ...loginFormData,
                          iAcceptAll: e.target.checked,
                        })
                      }
                    />
                    <label
                      htmlFor="login-terms"
                      style={{ color: "var(--dark-theme-white-color)" }}
                      className="auth-policy-label ms-2"
                    >
                      I accept all the{" "}
                    <Link
  className="auth-link"
  style={{
    textDecoration: "underline",
    color: "blue",
    cursor: "pointer",
  }}

>
  Terms & Conditions
</Link>
                    </label>
                  </div>
                  {/* <p
                    className="auth-forgot-link mt-0"
                    onClick={handleForgotPasswordClick}
                  >
                    <Link className="auth-link text-nowrap">Forgot Password?</Link>
                  </p> */}
                </div>
           <div className="auth-input-group mb-2 mt-4">
                  <button type="submit" className="auth-button" onClick={submitlogin} disabled={loading2}>
                    {loading2 ? (<><Spinner animation="border" /> Loading...</>) : ("Login")}
                  </button>
                </div>
                <div className="auth-input-group">
                  <button
                    type="button"
                    className="auth-button"
                    onClick={handleDemoLogin}
                    disabled={loading}
                  >
                    {loading ? (<><Spinner animation="border" /> Loading...</>) : ("Demo ID")}
                  </button>
                </div>
 
                {/* <div className="auth-input-group">
                  <button type="button" className="auth-download-button">
                    <i className="bi bi-android2 auth-icon"></i>
                    <span>Download App</span>
                  </button>

                </div> */}
                {/* <div className="auth-footer">
                  <p
                    className="auth-signup-link"
                    onClick={() => navigate("/registerPage")}
                  >
                    Create New Account
                  </p>
                </div> */}
              </form>
            </div>
          </div>
        </div>
      </div>

      <ForgotPassword
        forgotPasswordActive={forgotPasswordActive}
        setForgotPasswordActive={handleCloseForgotPassword}
        onClose={handleCloseForgotPassword}
      />

      <SignInHelp
        open={helpMode !== null}
        mode={helpMode || "password"}
        onClose={() => setHelpMode(null)}
      />

      {/* Registration Section */}
      <div
        className={`auth-backdrop ${regactive ? "auth-visible" : "auth-hidden"
          }`}
      ></div>
      <div
        role="dialog"
        tabIndex="-1"
        aria-modal="true"
        className={`auth-modal ${regactive ? "auth-visible" : "auth-hidden"}`}
      >
        <div className="auth-modal-dialog">
          <div className="auth-modal-content">
            <button
              type="button"
              onClick={() => {setregactive(false)
       setFormData(
       {  username: "",
    phoneNumber: "",
    cpassword: "",
    pwd: "",
    invite: "354409588405",
    imOver18: true,
    iAcceptAll: true}
       )


              }}
              className="auth-close-button"
            >
              <i className="bi bi-x auth-cross-icon"></i>
            </button>
            <div className="auth-form-box">
              {cookiesBlocked && (
                <p className="rb-cookie-warn" role="alert">
                  Cookies are blocked in this browser, so you won't stay
                  logged in. Enable cookies, or open this site in Chrome or
                  Safari{/(FBAN|FBAV|Instagram|Telegram)/i.test(navigator.userAgent)
                    ? " (use the menu → Open in browser)"
                    : ""}.
                </p>
              )}
              <div className="text-center text-black py-4 fs-4">
                <span>Register as New User</span>
              </div>
              <Form onSubmit={submitregister}>
                {/* Username */}
                <Form.Group className="">
                  <InputGroup className="">
                    <span className="text-black">
                      Mobile <span className="text-danger fs-5">*</span>
                    </span>

                    <div className="d-flex w-100">
                      <InputGroup.Text className="bg-primary text-white border-secondary d-flex align-items-center justify-content-center phone-eyes">
                        <img
                          src="/assets/images/india_flag-2016.jpg"
                          alt="Indian Flag"
                          className="me-1"
                          style={{ width: "20px", height: "14px" }}
                        />
                        <span className="me-1">+91</span>
                        {/* <span>▼</span> */}
                      </InputGroup.Text>

                      <Form.Control
                        type="text"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        maxLength={10}
                        onChange={handleInputChange}
                        className="bg-black  py-2 border-secondary phone-input-box"
                        aria-label="Phone Number"
                      />
                    </div>
                  </InputGroup>

                  <span className="text-black">
                    User ID <span className="text-danger fs-5">*</span>
                  </span>
                  <Form.Control
                    type="text"
                    placeholder="User ID"
                    name="username"
                    value={formData.username}
                    onChange={handleInputChange}
                    className=" py-2 border-secondary rounded-2 borderss"
                    aria-label="Username"
                  />
                </Form.Group>

                {/* Phone with Country Code */}

                {/* Password */}
                <div className="position-relative ">
                  <span className="text-black">
                    Password <span className="text-danger fs-5">*</span>
                  </span>

                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    name="cpassword"
                    value={formData.cpassword}
                    onChange={handleInputChange}
                    className=" py-2 password-input-box pr-5"
                    style={{ paddingRight: "2.5rem" }} // Ensure space for the eye icon
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "10px",
                      // transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#ccc",
                      zIndex: 10,
                    }}
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </span>
                </div>

                {/* Confirm Password */}
                <div className="position-relative ">
                  <span className="text-black">
                    {" "}
                    Confirm Password <span className="text-danger fs-5">*</span>
                  </span>

                  <Form.Control
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                    name="pwd"
                    value={formData.pwd}
                    onChange={handleInputChange}
                    className="  py-2 border-secondary password-input-box"
                    style={{ paddingRight: "2.5rem" }}
                    aria-label="Confirm Password"
                  />
                  <span
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "10px",
                      // transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#ccc",
                      zIndex: 10,
                    }}
                  >
                    {showConfirmPassword ? (
                      <EyeOff size={18} />
                    ) : (
                      <Eye size={18} />
                    )}
                  </span>
                </div>

                {/* opt form */}
                {/* <Form.Group className="">
                  <div className="position-relative">
                    <span className="text-black">
                      OTP Code <span className="text-danger fs-5"></span>
                    </span>
                    <Form.Control
                      type="text"
                      placeholder="OTP Code"
                      name="otp"
                      value={formData.otp}
                      onChange={handleInputChange}
                      className=" py-2 border-secondary rounded-2 borderss"
                      aria-label="otp"
                    />
                    <button className="btn btn-warning" 
                      style={{ position: "absolute", top: "19px", right: 0 }}
                    >
                      Send Otp
                    </button>
                  </div>
                </Form.Group> */}

                {/* invitation form */}
                <Form.Group className="d-none">
                  <span className="text-black">
                    REFERRAL CODE <span className="text-danger fs-5"></span>
                  </span>
                  <Form.Control
                    type="text"
                    placeholder="Referral code"
                    name="invite"
                    value={formData.invite}
                    onChange={handleInputChange}
                    className=" py-2 border-secondary rounded-2 borderss"
                    aria-label="invite"
                  />
                </Form.Group>

                {/* Checkboxes */}
                <div className=" d-none">
                  <div className="d-flex align-items-center ">
                    <input
                      className="form-check-input shadow-none border-0 me-2 font-size-labelss"
                      type="checkbox"
                      name="imOver18"
                      checked={formData.imOver18}
                      onChange={handleInputChange}
                      id="imover18"
                    />
                    <span
                      className="checkbox-label font-size-labelss"
                      style={{ marginLeft: "33px" }}
                    >
                      I'm over 18
                    </span>
                  </div>

                  <div className="d-flex align-items-center">
                    <input
                      className="form-check-input shadow-none border-0 me-2  font-size-labelss checked:bg-yellow-500"
                      type="checkbox"
                      name="iAcceptAll"
                      checked={formData.iAcceptAll}
                      onChange={handleInputChange}
                      id="iaccept"
                    />
                    <span
                      className="checkbox-label font-size-labelss "
                      style={{ marginLeft: "33px" }}
                    >
                      I accept all the{" "}
                      <a
                        href="##"
                        className="text-warning text-decoration-none font-size-labelss"
                      >
                        Terms & Conditions
                      </a>
                    </span>
                  </div>
                </div>
                <span className="text-black fs-7">
                  By clicking on the Register button, you agree to the <span className="text-red"   onClick={() => setShowTerms(true)}>Terms and Conditions</span> and confirm that you are over 18 years old.
                </span>
                {/* Register Button */}
                <Button
                  variant="primary"
                  type="submit"
                  className="w-100 py-2 text-dark fw-bold  mt-3"
                  style={{
                    background: "#78bff8",
                    height: "50px",
                    fontSize: "20px",
                  }}
                >
                  Register
                </Button>
                <div className="d-flex align-items-center">
                  {/* <span className="checkbox-label font-size-labelss " onClick={() => setactive(true)} style={{ marginLeft: "33px" }}>
                          Already have an account ?{" "}
                          <a
                            href="#"
                            className="text-warning text-decoration-none font-size-labelss"
                          >
                            Login
                          </a>
                        </span> */}
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
{showTerms && (
  <div
    style={styles.overlay}
    onClick={() => setShowTerms(false)}
  >
    <div
      style={styles.modal}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Header */}
      <div style={styles.header}>
        <h2 style={styles.title}>Terms & Conditions</h2>
        <span style={styles.close} onClick={() => setShowTerms(false)}>
          ✕
        </span>
      </div>

      {/* Body */}
      <div style={styles.body}>
        <p>
          Welcome to our platform. By accessing or using our services, you agree
          to be bound by these terms.
        </p>

        <div style={styles.card}>
          <h4>🔐 Account Responsibility</h4>
          <p>You are responsible for maintaining your account security.</p>
        </div>

        <div style={styles.card}>
          <h4>📄 Accurate Information</h4>
          <p>All details provided must be correct and up to date.</p>
        </div>

        <div style={styles.card}>
          <h4>🔄 Updates</h4>
          <p>We may update terms anytime without prior notice.</p>
        </div>

        <div style={styles.card}>
          <h4>🔞 Age Restriction</h4>
          <p>You must be 18+ to use this platform.</p>
        </div>
      </div>

      {/* Footer */}
      <div style={styles.footer}>
        <button
          style={styles.declineBtn}
          onClick={() => setShowTerms(false)}
        >
          Decline
        </button>

        <button
          style={styles.acceptBtn}
          onClick={() => {
            setLoginFormData({
              ...loginFormData,
              iAcceptAll: true,
            });
            setShowTerms(false);
          }}
        >
          Accept & Continue
        </button>
      </div>
    </div>
  </div>
)}
    </>
  );
}
